import React from 'react';

/**
 * Wiederverwendbarer Container für Auth-Formulare
 * Bietet konsistentes Design für Login und Admin-Login
 */
function AuthFormContainer({ 
  title, 
  subtitle, 
  error, 
  loading, 
  onSubmit, 
  children,
  buttonText = 'Login',
  footerText 
}) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-slate-800/50 border border-purple-500/30 rounded-lg p-8">
          <h1 className="text-3xl font-bold mb-2 text-center">{title}</h1>
          <p className="text-slate-400 text-center mb-6">{subtitle}</p>

          <form onSubmit={onSubmit}>
            {error && (
              <div className="bg-red-900/30 border border-red-500 text-red-200 p-3 rounded-lg mb-4 text-sm">
                {error}
              </div>
            )}

            {children}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 text-white font-bold py-3 rounded-lg transition-all"
            >
              {loading ? 'Authenticating...' : buttonText}
            </button>
          </form>

          {footerText && (
            <div className="mt-6 pt-6 border-t border-purple-500/30 text-center">
              <p className="text-xs text-slate-400">{footerText}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthFormContainer;
